import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";

import ThemeModeToggle from "../components/theme-mode-toggle.component";

const NoInternetPage = () => {
  return (
    <Box
      sx={{ minHeight: "100vh", display: "flex", alignItems: "center", py: 4 }}
    >
      <Container maxWidth="sm">
        <Stack spacing={2.5}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <ThemeModeToggle />
          </Box>

          <Card>
            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
              <Stack spacing={3} alignItems="center" textAlign="center">
                <Typography variant="h4">Connection issue</Typography>
                <Typography color="text.secondary">
                  There may be something wrong with your internet connection.
                </Typography>
                <Button
                  title="Refresh"
                  onClick={() => {
                    const queryParams = new URLSearchParams(
                      window?.location?.search,
                    );
                    const previousRoute = queryParams.get("previousRoute");
                    if (previousRoute) {
                      window.location.href = `${window.location.origin}/${previousRoute}`;
                    } else {
                      window.location.href = window.location.origin;
                    }
                  }}
                >
                  Refresh
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

export default NoInternetPage;
